export const getOperands = (state) => {
    const fields = state?.map((item) =>
        item.structure === 'patient'
            ? { ...item, structure: null, field: item.field.id }
            : { ...item, field: item.field.id }
    );
    const operands = state?.length && JSON.parse(JSON.stringify(fields));
    operands?.map((item) => {
        delete item.index;
        delete item.errorMessage;
        return item;
    });

    return operands;
};
